/**
 * Lógica de generación de imagen para Instagram
 * Ahora prioriza la carga manual si existe.
 */
export const getInstagramDataURL = async (data) => {
  // Si el usuario subió su propia portada (Flyer de Canva)
  if (data.customFlyer) {
    return data.customFlyer;
  }

  // Si no hay portada manual, devolvemos la imagen de portada original de la propiedad
  // (O podrías mantener aquí el código de dibujo automático si lo deseas)
  const coverImage = data.images[data.coverIndex]?.src;
  return coverImage || '';
};

export const downloadInstagramPost = async (data) => {
  const dataUrl = await getInstagramDataURL(data);
  if (!dataUrl) return alert("No hay imagen disponible para descargar.");
  
  const link = document.createElement('a');
  link.download = `Portada_Arboleda_${data.city || 'Propiedad'}.png`;
  link.href = dataUrl;
  link.click();
};